import { createOperationClient, getBackendEndpoint } from "@/services/react-query.service/graphql-client";

import { createDownloadLinkMutationDocument } from "../hooks/api/signed-url.gql";

type DownloadMode = "DOWNLOAD" | "OPEN";

async function createFileDownloadLink(fileId: string): Promise<string | null> {
  const client = createOperationClient("createDownloadLink");
  const data = await client.request(createDownloadLinkMutationDocument, { input: { fileId } });
  return data?.createDownloadLink?.id ?? null;
}

function triggerBrowserDownload({
  downloadLinkId,
  fileName,
  mode = "DOWNLOAD",
}: {
  downloadLinkId: string;
  fileName: string;
  mode?: DownloadMode;
}): void {
  const downloadUrl = new URL(`/download/${downloadLinkId}`, getBackendEndpoint() || window.location.origin);
  const anchor = document.createElement("a");
  if (mode === "DOWNLOAD") {
    downloadUrl.searchParams.set("download", "1");
    anchor.setAttribute("download", fileName);
  } else {
    anchor.setAttribute("target", "_blank");
    anchor.setAttribute("rel", "noopener noreferrer");
  }
  anchor.href = downloadUrl.toString();
  document.body.append(anchor);
  anchor.click();
  anchor.remove();
}

interface DownloadFileWithFeedbackInput {
  fileId: string;
  fileName: string;
  mode?: DownloadMode;
  onError: () => void;
}

export async function downloadFileWithFeedback({
  fileId,
  fileName,
  mode = "DOWNLOAD",
  onError,
}: DownloadFileWithFeedbackInput): Promise<boolean> {
  try {
    const downloadLinkId = await createFileDownloadLink(fileId);
    if (!downloadLinkId) {
      onError();
      return false;
    }
    triggerBrowserDownload({ downloadLinkId, fileName, mode });
    return true;
  } catch {
    onError();
    return false;
  }
}
